import { NgModule } from '@angular/core';
import { HasPermissionDirective } from './components/directives/has-permission.directive';

@NgModule({
  imports: [],
  declarations: [HasPermissionDirective],
  exports: [HasPermissionDirective]
})
export class DirectivesModule { }